import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { EmptyState, Sidebar } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { AddMetadataMenu } from './AddMetadataMenu/AddMetadataMenu';
import { useDocumentMetadata } from './DocumentMetadataProvider';
import { MetadataField } from './MetadataField';
export function MetadataList() {
    const { data, activeEntries, documentId } = useDocumentMetadata();
    const customProperties = data.properties.filter(({ property }) => property.companyId);
    const commonProperties = data.properties.filter(({ property }) => activeEntries.includes(property.name) && !property.companyId);
    return (<Fragment>
      {Boolean(customProperties.length) && (<Sidebar.Section id="custom-metadata" title={t({ message: 'Custom metadata', comment: 'Metadata section title' })} actions={<AddMetadataMenu documentId={documentId} where={{ companyId: { isNull: false } }}/>}>
          <Sidebar.DefinitionList>
            {customProperties.map(({ property, pair }) => (<MetadataField key={property.id} documentId={documentId} property={property} pair={pair}/>))}
          </Sidebar.DefinitionList>
        </Sidebar.Section>)}
      <Sidebar.Section id="common-metadata" title={t({ message: 'Standard metadata', comment: 'Metadata section title' })} actions={<AddMetadataMenu documentId={documentId} where={{ companyId: { isNull: true } }}/>}>
        <Sidebar.DefinitionList>
          {!commonProperties.length && (<EmptyState icon={<Falcon icon="exclamation-circle"/>} title={t({
                message: 'Empty',
                comment: 'Document sidebar, no common metadata added',
                context: 'metadata',
            })} description={t({
                message: 'No common metadata added yet',
                comment: 'Document sidebar, no common metadata added',
                context: 'metadata',
            })}/>)}

          {commonProperties.map(({ property, pair }) => (<MetadataField key={property.id} documentId={documentId} property={property} pair={pair}/>))}
        </Sidebar.DefinitionList>
      </Sidebar.Section>
    </Fragment>);
}
